import React from 'react'
import { Button, Modal } from 'antd'
import './MortgageGPT.css'

const LimitReachedModal = ({ isOpen, onClose }) => {
    const serviceList = [
        {
            key: 'unlimited-1003-pdf-fnm-3-4-exports',
            text: 'Unlimited 1003 PDF & FNM 3.4 exports',
        },
        {
            key: 'unlimited-guidelinegpt',
            text: 'Unlimited MortgageGPT',
        },
        {
            key: 'call-reports',
            text: 'Call reports',
        },
        {
            key: 'customizable-personal-website-and-more',
            text: 'Customizable personal website and more...',
        },
    ]

    return (
        <Modal
            className="limit-reached-modal"
            styles={{ mask: { backgroundColor: 'rgba(0, 0, 0, 0.80)' } }}
            maskClosable={true}
            width={566}
            open={isOpen}
            centered
            title=""
            onCancel={onClose}
            footer={null}
        >
            <div className="limit-reached-title">Upgrade to Business</div>
            <div className="limit-reached-description">
                You've hit the limit for free chats. You can elevate your
                potential to new heights with our Business plan.
            </div>
            <div className="limit-reached-price">
                <span className="amount">$35</span>
                <span className="unit">/mo per company</span>
            </div>
            <div className="limit-reached-divider" />

            <div className="limit-reached-service-list">
                {serviceList.map((item) => {
                    return (
                        <div key={item.key} className="service-item">
                            <img src="/images/paywall-check.svg" />
                            <div className="service-item-text">{item.text}</div>
                        </div>
                    )
                })}
            </div>

            <Button
                type="primary"
                size="large"
                className="limit-reached-primary-button"
                onClick={() =>
                    window.open('/signup?utm_source=guidelinegpt', '_blank')
                }
            >
                Create account and upgrade
            </Button>

            <Button
                type="link"
                size="large"
                onClick={() => window.open('/', '_blank')}
                style={{ fontWeight: 300, color: '#325ceb' }}
            >
                Already have an account? Log in
            </Button>
        </Modal>
    )
}

export default LimitReachedModal
